// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/home';
import templateAbout from './routes/about';
import templateExperiences from './routes/experiences';
import templateAllExperiences from './routes/all-experiences';
import templateDestinations from './routes/destinations';
import singleExperiences from './routes/single-experiences';
import singleRentals from './routes/single-rentals';
import singleBlog from './routes/single-blog';
import singleAccommodations from './routes/single-accommodations';
import templateNewsAndPress from './routes/news-and-press';
import taxDestinations from './routes/destinations-data';
import taxType from './routes/type-data';
import templatePrivateRentals from './routes/private-rentals';
import templateContact from './routes/contact';
import templateYourWishlist from './routes/your-wishlist';
import templateWishlistLanding from './routes/wishlist-landing';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  templateHome,
  // About page
  templateAbout,
  // Experiences page
  templateExperiences,
  // All Experiences page
  templateAllExperiences,
  //Destinations page
  templateDestinations,
  // Private rentals page
  templatePrivateRentals,
  //taxonomy Destinations
  taxDestinations,
  // Taxonomy Type
  taxType,
  //News page
  templateNewsAndPress,
  // Contact page
  templateContact,
  // Single Experiences
  singleExperiences,
  // Single Rentals
  singleRentals,
  // Single Blog
  singleBlog,
  // Single Accommodations
  singleAccommodations,
  // Your Wishlist page
  templateYourWishlist,
   // Wishlist Landing page
   templateWishlistLanding,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js